import { Injectable } from '@angular/core';
import {
  RemoteMembershipSettingModel, PagerModel, RemoteMembershipSettingExtendedPagedModel, RemoteMembershipSettingExtendedModel
} from '../models';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ServiceHelpers } from 'src/app/shared/service.helpers';
import { GlobalConsts } from 'src/app/shared/global.vars';

@Injectable({
  providedIn: 'root'
})
export class RemoteMembershipSettingsService {

  constructor(
    private httpClient: HttpClient,
    private serviceHelpers: ServiceHelpers
  ) { }

  getMyRemotesExtended(): Observable<RemoteMembershipSettingExtendedModel[]> {
    return this.httpClient.get<RemoteMembershipSettingExtendedModel[]>(
      GlobalConsts.apiBaseUrl + 'RemoteMembershipSetting/GetMyRemotesExtended',
      this.serviceHelpers.getCommonHeaders());
  }

  openCloseRemote(input: string): Observable<any> {
    return this.httpClient.get<any>(
      GlobalConsts.apiBaseUrl + 'RemoteMembershipSetting/OpenCloseRemote/' + input,
      this.serviceHelpers.getCommonHeaders());
  }

  requestAccess(accessCode: string): Observable<any> {
    return this.httpClient.get<any>(
      GlobalConsts.apiBaseUrl + 'RemoteMembershipSetting/RequestAccess/' + accessCode,
      this.serviceHelpers.getCommonHeaders());
  }
}
